export class SmsConfig {
  accountSid:string;
  authToken:string;
  fromNumber:string;
  testNumber:string;
  maxShare:string;
  until:string;

  constructor(json:any) {

    if(json!=null) {
      this.accountSid = json.accountSid;
      this.authToken = json.authToken;
      this.fromNumber = json.fromNumber;
      this.testNumber = json.testNumber;
      this.maxShare = json.maxShare;
      this.until = json.until;
    }
  }
}
